import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconHouse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 21,
	viewBox: "0 0 26 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.5293 21V13.5882H15.4705V21H21.647V11.1176H25.3529L12.9999 0L0.646973 11.1176H4.35285V21H10.5293Z",
		fill: "currentColor"
	})
});
export default SvgIconHouse;
